import { useMutation } from '@tanstack/react-query';
import {
  getPreSignedUrlForUpload,
  recordCompletedPresignedUpload,
} from '../services/storage.service';
import {
  GetPreSignedUrlForUploadPayload,
  GetPreSignedUrlForUploadResponse,
} from '../types/storage.types';
import { useConfig } from 'hooks/use-config';
import { useToast } from 'hooks/use-toast';

const usePresignedUploadMutation = (checkLibraryStorage: boolean) => {
  const { configurationSettings } = useConfig();
  const blocksKey = configurationSettings?.blocksKey || '';
  const { toast } = useToast();

  return useMutation<
    GetPreSignedUrlForUploadResponse,
    Error,
    GetPreSignedUrlForUploadPayload
  >({
    mutationKey: ['getPreSignedUrlForUpload', checkLibraryStorage],
    mutationFn: (payload) =>
      getPreSignedUrlForUpload(payload, blocksKey, { checkLibraryStorage }),
    onError: (error) => {
      toast({
        title: 'Upload Error',
        description: error.message || 'Failed to get upload URL',
        variant: 'destructive',
      });
    },
  });
};

export const useGetPreSignedUrlForUpload = () => usePresignedUploadMutation(false);

/** Chat attachments and KB files: checks library storage before issuing a slot. */
export const useGetLibraryPreSignedUrlForUpload = () => usePresignedUploadMutation(true);

export const useCompletePreSignedUpload = () => {
  const { configurationSettings } = useConfig();
  const blocksKey = configurationSettings?.blocksKey || '';

  return useMutation<{ recorded: number }, Error, string[]>({
    mutationKey: ['completePreSignedUpload'],
    mutationFn: (fileIds) => recordCompletedPresignedUpload(fileIds, blocksKey),
  });
};
